import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ICardStore, IconSizeEnum, SdBorderWrapperComponent, SdIconComponent } from '@seb/web-design-system/core';

@Component({
  selector: 'wc-relay-point-recap',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslatePipe,
    SdBorderWrapperComponent,
    SdIconComponent
  ],
  templateUrl: './relay-point-recap.component.html'
})
export class RelayPointRecapComponent {

  iconSize = IconSizeEnum;

  @Input()
  store: ICardStore;

  @Input()
  isForfait: boolean;
}
